import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import type { TemplateStack } from '@/lib/template-utils';

export function useTemplateStacks(filters?: { category?: string; complianceFramework?: string }) {
  const [stacks, setStacks] = useState<TemplateStack[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    fetchStacks();
  }, [filters?.category, filters?.complianceFramework]);

  const fetchStacks = async () => {
    try {
      setLoading(true);
      setError(null);

      let query = supabase
        .from('template_stacks')
        .select('*')
        .eq('is_active', true);

      if (filters?.category) {
        query = query.eq('category', filters.category);
      }

      if (filters?.complianceFramework) {
        query = query.eq('compliance_framework', filters.complianceFramework);
      }

      const { data, error: queryError } = await query.order('created_at', {
        ascending: false,
      });

      if (queryError) throw queryError;

      setStacks((data as TemplateStack[]) || []);
    } catch (err) {
      console.error('Error fetching stacks:', err);
      setError(err as Error);
      setStacks([]);
    } finally {
      setLoading(false);
    }
  };

  return { stacks, loading, error, refetch: fetchStacks };
}

